<template>
  <transition name="zoom">
    <div>
      <el-card v-loading="loading"
               class="page-box detail-box settle"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">基础信息</div>
          <span class="close"  @click="closeDetail">
          <icon-svg iconClass="close-small"></icon-svg>
        </span>
        </div>
        <div class="order-info">
          <div class="content">
            <div class="content-info">订 单 号：</div>
            <div class="content-info">{{entity.orderNo}}</div>
          </div>
          <div class="content">
            <div class="content-info">客户名称：</div>
            <div class="content-info">{{entity.name}}</div>
          </div>
          <div class="content">
            <div class="content-info">联系方式：</div>
            <div class="content-info">{{entity.phone}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">服务地址：</div>
            <div class="content-info">{{entity.addr}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">特殊说明：</div>
            <div class="content-info">{{entity.tsRemark}}</div>
          </div>
          <div class="content">
            <div class="content-info">服务时间：</div>
            <div class="content-info">
              {{entity.beginDate}}
                <span v-if="!!entity.beginDate"> 至 </span>
              {{entity.endDate}}
            </div>
          </div>
          <div class="content">
            <div class="content-info">服务价格：</div>
            <div class="content-info">{{entity.orderAmount}}</div>
          </div>
          <br/>
          <div class="content">
            <div class="content-info">服务开始时间：</div>
            <div class="content-info">{{entity.beginTime}}</div>
          </div>
          <div class="content">
            <div class="content-info">服务截至时间：</div>
            <div class="content-info">{{entity.endTime}}</div>
          </div>
        </div>
        <div class="order-info">
          <div class="title-no"> 服务方案 </div>
          <el-table
            :data="entity.orderDetailList"
            style="width: 100%">
            <el-table-column
              prop="serviceName"
              label="服务名称">
            </el-table-column>
            <el-table-column
              prop="serviceUnitPrice"
              label="服务单价">
            </el-table-column>
            <el-table-column
              prop="servicePrice"
              label="本次服务价格">
            </el-table-column>
          </el-table>
        </div>

        <div class="order-info">
          <div class="title">人员安排 </div>
          <div class="content">
            <div class="content-info">负 责 人：</div>
            <div class="content-info">{{entity.leaderName}}</div>
          </div>
          <div class="content">
            <div class="content-info">服务人员：</div>
            <div class="content-info">{{orderEmployees}}</div>
          </div>
        </div>
        <div class="order-info">
          <div class="title">评价回访</div>
          <div class="content">
            <div class="content-info">客户评价：</div>
            <div class="content-info">
              <template v-if="entity.evaluate==='1'">#非常满意#</template>
              <template v-if="entity.evaluate==='2'">#很满意#</template>
              <template v-if="entity.evaluate==='3'">#还不错#</template>
              <template v-if="entity.evaluate==='4'">#一般#</template>
              <template v-if="entity.evaluate==='5'">#差#</template>
            </div>
          </div>
          <div class="content">
            <div class="content-info">评价时间：</div>
            <div class="content-info">{{entity.evaluateTime}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">评价内容：</div>
            <div class="content-info">{{entity.evaluateContent}}</div>
          </div>
          <div class="content">
            <div class="content-info">回访时间：</div>
            <div class="content-info">{{entity.visitTime}}</div>
          </div>
          <div class="content">
            <div class="content-info">回访人员：</div>
            <div class="content-info">{{entity.visitName}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">回访结果：</div>
            <div class="content-info">{{entity.visitContent}}</div>
          </div>
        </div>
        <div class="close-win">
          <el-button type="text"  style="width: 120px" @click="$emit('order-view','order-list')">关闭</el-button>
        </div>
      </el-card>
    </div>
  </transition>

</template>

<script>
import {order, dict} from '@/api'

export default {
  name: 'PolicyDetail',
  components: {},
  data () {
    return {
      tableData: [],
      dialogVisible: false,
      entity: {
        orderDetailList: []
      },
      loading: false
    }
  },
  computed: {
    orderEmployees: function () {
      let orderEmployeeArray = []
      for (let entity of this.entity.orderEmployeeList) {
        orderEmployeeArray.push(entity.name)
      }
      // `this` 指向 vm 实例
      return orderEmployeeArray.toString()
    }
  },
  methods: {
    changeEvent (value) {
      this.getData(value)
    },
    async getData (param) {
      this.loading = true
      let {data} = await order.getOrderDetail(param)
      this.entity = data
      this.loading = false
    },
    closeDetail () {
      this.$emit('order-view', 'order-list')
    }
  }
}
</script>

<style lang="scss" scoped>
  .settle {
    min-height: calc(100vh - 200px);
  }
  .page-content {
    min-width: 1000px;
  }
  .el-card {
    /*position: absolute;*/
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .order-info {
      margin-top: 10px;
      .title {
        margin: 30px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom:1px solid #ebeef5;
      }
      .title-no {
        margin: 30px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
      }
      .content {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        display: inline-block;
        .content-info {
          display: inline;
        }
      }
      .content-long {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        .content-info {
          display: inline;
        }
      }
    }
    .close-win {
      text-align: center;
    }
  }

</style>
